var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VView',{staticClass:"contest-game"},[_c('VGame',{on:{"end":function($event){return _vm.onGameEnd($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }